import { createSelector } from 'reselect'

import { selectQbrState } from './selectQbrState'

export const selectQBRLastStep = createSelector([selectQbrState], (state) => state.lastStep)
